import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, useBreakpointValue } from '@chakra-ui/react';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

export default function Cardslider({ children}) {
  // Determine the maximum items that can fit on current screen
  const maxItemsPerScreen = useBreakpointValue({
    base: 1,    // mobile
    md: 2,      // tablet
    lg: 3,      // desktop
    xl: 4       // large desktop
  });

  // Handle empty or undefined children
  if (!children) {
    return null;
  }

  // Convert single child to array
  const childArray = Array.isArray(children) ? children : [children];
  
  if (childArray.length === 0) {
    return null;
  }

  let len = childArray.length;
  
  // Use flex layout if we have fewer items than the screen can show
  const useFlexLayout = len <= maxItemsPerScreen;

  if (useFlexLayout) {
    return (
      <Box 
        px={{ base: 4, md: 12 }}
        py={2}
        display="flex"
        flexWrap="wrap"
        gap={{ base: 4, md: 6 }}
        justifyContent={{ base: "center", sm: "flex-start" }}
        alignItems="stretch"
        overflow="hidden"
      >
        {childArray}
      </Box>
    );
  }

  let settings = {
    infinite: len > 4,
    speed: 500,
    slidesToShow: Math.min(4, len),
    autoplay: len > 4,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    initialSlide: 0,
    rows: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    arrows: len > 4,
    variableWidth: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          infinite: len > 3,
          slidesToShow: Math.min(3, len),
          slidesToScroll: 1,
          arrows: len > 3,
          dots: false,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          infinite: len > 2,
          slidesToShow: Math.min(2, len),
          slidesToScroll: 1,
          arrows: len > 2,
          dots: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          infinite: len > 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: len > 1,
          dots: len > 1,
          centerMode: false,
          centerPadding: "0px",
          variableWidth: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          infinite: len > 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: len > 1,
          centerMode: false,
          centerPadding: "0px",
          variableWidth: false,
        }
      }
    ]
  };

  return (
    <Box 
      px={{ base: 4, md: 12 }}
      py={2}
      position="relative"
      overflow="hidden"
      sx={{
        '.slick-slide': {
          padding: '0 12px',
        },
        '.slick-list': {
          margin: '0 -12px',
        },
        '.slick-prev': {
          left: '-36px',
          zIndex: 2,
          width: '32px',
          height: '32px',
          '&:before': {
            fontSize: '20px',
            color: 'var(--chakra-colors-primary-900)',
            opacity: 1,
          },
          '@media (max-width: 768px)': {
            left: '-20px',
          }
        },
        '.slick-next': {
          right: '-36px',
          zIndex: 2,
          width: '32px',
          height: '32px',
          '&:before': {
            fontSize: '20px',
            color: 'var(--chakra-colors-primary-900)',
            opacity: 1,
          },
          '@media (max-width: 768px)': {
            right: '-20px',
          }
        },
        '.slick-track': {
          display: 'flex',
          alignItems: 'stretch',
        },
        '.slick-slide > div': {
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        },
        '.slick-dots': {
          bottom: '-30px',
        },
        '.slick-dots li button:before': {
          fontSize: '9px',
          color: 'var(--chakra-colors-secondary-900)',
          opacity: 0.8,
        },
        '.slick-dots li.slick-active button:before': {
          color: 'var(--chakra-colors-dark-900)',
          opacity: 1,
        },
        '.slick-dots li button:hover:before': {
          color: 'var(--chakra-colors-secondary.100)',
        },
      }}
    >
      <Slider {...settings}>
        {childArray}
      </Slider>
    </Box>
  );
}